"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data_structures_1 = require("@tableau/data-structures");
var React = require("react");
var SchemaViewerBlank_1 = require("../../../../gen-src/icons/SchemaViewerBlank");
var SchemaViewerBoolDiscrete_1 = require("../../../../gen-src/icons/SchemaViewerBoolDiscrete");
var SchemaViewerCurrencyDiscrete_1 = require("../../../../gen-src/icons/SchemaViewerCurrencyDiscrete");
var SchemaViewerDateDiscrete_1 = require("../../../../gen-src/icons/SchemaViewerDateDiscrete");
var SchemaViewerDateTimeDiscrete_1 = require("../../../../gen-src/icons/SchemaViewerDateTimeDiscrete");
var SchemaViewerNumberDiscrete_1 = require("../../../../gen-src/icons/SchemaViewerNumberDiscrete");
var SchemaViewerTextDiscrete_1 = require("../../../../gen-src/icons/SchemaViewerTextDiscrete");
var globalTypes_1 = require("../../../../gen-src/queries/globalTypes");
function RemoteTypeIcon(props) {
    // References for mapping https://opengrok/source/xref/teams_near/modules/connectors/tabmixins/main/db/OLEDBProtocol.cpp#2389
    // https://opengrok/source/xref/teams_near/modules/platform/tabdoc/main/interface/DataTypeIcons.cpp
    // https://opengrok/source/xref/teams_near/modules/platform/tabcore/public/core/TableauDBType
    switch (props.remoteType) {
        case globalTypes_1.RemoteType.BOOL:
        case globalTypes_1.RemoteType.WDC_BOOL:
            return React.createElement(SchemaViewerBoolDiscrete_1.SvgSchemaViewerBoolDiscrete, null);
        case globalTypes_1.RemoteType.CY:
            return React.createElement(SchemaViewerCurrencyDiscrete_1.SvgSchemaViewerCurrencyDiscrete, null);
        case globalTypes_1.RemoteType.DATE:
        case globalTypes_1.RemoteType.DBDATE:
        case globalTypes_1.RemoteType.WDC_DATE:
            return React.createElement(SchemaViewerDateDiscrete_1.SvgSchemaViewerDateDiscrete, null);
        case globalTypes_1.RemoteType.DBTIME:
        case globalTypes_1.RemoteType.DBTIMESTAMP:
        case globalTypes_1.RemoteType.FILETIME:
        case globalTypes_1.RemoteType.WDC_DATETIME:
            return React.createElement(SchemaViewerDateTimeDiscrete_1.SvgSchemaViewerDateTimeDiscrete, null);
        case globalTypes_1.RemoteType.I1:
        case globalTypes_1.RemoteType.I2:
        case globalTypes_1.RemoteType.I4:
        case globalTypes_1.RemoteType.I8:
        case globalTypes_1.RemoteType.NUMERIC:
        case globalTypes_1.RemoteType.NULL:
        case globalTypes_1.RemoteType.R4:
        case globalTypes_1.RemoteType.R8:
        case globalTypes_1.RemoteType.UDT:
        case globalTypes_1.RemoteType.UI1:
        case globalTypes_1.RemoteType.UI2:
        case globalTypes_1.RemoteType.UI4:
        case globalTypes_1.RemoteType.UI8:
        case globalTypes_1.RemoteType.DECIMAL:
        case globalTypes_1.RemoteType.VARNUMERIC:
        case globalTypes_1.RemoteType.WDC_FLOAT:
        case globalTypes_1.RemoteType.WDC_INT:
            return React.createElement(SchemaViewerNumberDiscrete_1.SvgSchemaViewerNumberDiscrete, null);
        case globalTypes_1.RemoteType.ARRAY:
        case globalTypes_1.RemoteType.BSTR:
        case globalTypes_1.RemoteType.BYREF:
        case globalTypes_1.RemoteType.BYTES:
        case globalTypes_1.RemoteType.GUID:
        case globalTypes_1.RemoteType.STR:
        case globalTypes_1.RemoteType.WSTR:
        case globalTypes_1.RemoteType.VARIANT:
        case globalTypes_1.RemoteType.VECTOR:
        case globalTypes_1.RemoteType.WDC_STRING:
            return React.createElement(SchemaViewerTextDiscrete_1.SvgSchemaViewerTextDiscrete, null);
        case globalTypes_1.RemoteType.EMPTY:
        case globalTypes_1.RemoteType.ERROR:
        case globalTypes_1.RemoteType.HCHAPTER:
        case globalTypes_1.RemoteType.IDISPATCH:
        case globalTypes_1.RemoteType.IUNKNOWN:
        case globalTypes_1.RemoteType.PROPVARIANT:
        case globalTypes_1.RemoteType.RESERVED:
        case globalTypes_1.RemoteType.WDC_GEOMETRY:
            return React.createElement(SchemaViewerBlank_1.SvgSchemaViewerBlank, null);
        default:
            data_structures_1.assertNever(props.remoteType);
            return React.createElement(SchemaViewerBlank_1.SvgSchemaViewerBlank, null);
    }
}
exports.RemoteTypeIcon = RemoteTypeIcon;
//# sourceMappingURL=RemoteTypeIcon.js.map